import styled from 'styled-components';

/**
 * The Dashboard's tab row in the header, on a desktop. (On a phone the tabs
 * sit under the header in the shared TabsWrapper, which scrolls sideways.)
 *
 * Tabs are 170px wide each, which fits four beside the title only on a wide
 * screen: on a laptop the fourth one ran off the right edge. Below 1450px they
 * size to their own label instead, with tighter padding and type.
 *
 * The rules reach into the tabs from here (attribute selector, so they beat
 * Tab's own single-class styles) rather than adding breakpoint props to the
 * shared Tab for one screen.
 */
export const DashboardTabRow = styled.div`
  display: flex;
  gap: 16px;
  margin: 32px 0;

  [role='tab'] {
    width: 170px;
    white-space: nowrap;
  }

  @media (max-width: 1450px) {
    gap: 12px;

    [role='tab'] {
      width: auto;
      min-width: 100px;
      padding: 0 16px;
      font-size: 13px;
    }
  }

  @media (max-width: 1000px) {
    gap: 8px;

    [role='tab'] {
      min-width: 0;
      padding: 0 12px;
      font-size: 12px;
    }
  }
`;
